<template>
  <div>
    <v-col cols="12" sm="12">
      <b-alert
          show
          variant="light"
          class="alert alert-custom alert-success alert-shadow fade show gutter-b mb-0"
      >
        <div class="alert-text mt-2 text-center">
          <h1 style="color: #000000"><b>Advertisements</b></h1>
        </div>
      </b-alert>
    </v-col>
    <v-col cols="12" sm="12">
      <AdsTable/>
    </v-col>
  </div>
</template>

<script>
import AdsTable from "@/view/pages/realstate/market_insights/inc/AdsTable.vue";

export default {
  name: "advertisements",
  components: {
    AdsTable
  },
  mounted() {},
  methods: {}
};
</script>
